import React from 'react'
import { Grid, Button, List, ListItem, ListItemAvatar, ListItemText, Typography  } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { reduxForm, Field } from 'redux-form';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
import RenderSelectFieldRedux from '../Complements/RenderSelectFieldRedux'
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import PhoneIcon from '@material-ui/icons/Phone';

const useStyles = makeStyles(theme => ({
    textField: {
        width: 200,
    },
    margin: {
        margin: theme.spacing(1),
    },
    submit: {
        margin: (3, 0, 2),
        fontWeight: 'bold',
        fontSize: '0.6rem',
        borderLeft: '3px solid #0073D2',
        color: '#1a1919',
        backgroundColor: "#ffffff",
        //fontFamily: 'Ubuntu',
        "&:hover": {
            backgroundColor: "#ffffff",
            borderLeft: '3px solid #0073D2',
        }
    },
    buttonStandard: {
        fontSize: '1rem',
        color: '#ffffff',
        borderRadius: '4px',
        '&.Mui-disabled': {
            backgroundColor: "#a7a8a8",
        },
        '&:hover': {
            backgroundColor: "#706D85",
        },
        backgroundColor: "#2E2757",
        //fontFamily: 'MyriadPro-Bold',
    },
    divStandard: {
        padding: "20px",
        // border: '2px solid #BEBCC0',
        backgroundColor: theme.palette.type === 'dark' ? '#4a4a4a' : '#fafafa',
        borderRadius: "16px",
        // boxShadow: '4px 4px 4px 0px rgba(46,46,46,0.75)'
    }
}));

const validate = values => {
    const error  = {}
    if (!values.cellphone) {
        error.cellphone = "El número de celular es obligatorio"
    }
    if (!values.amount) {
        error.amount = "El monto a recargar es obligatorio"
    }
    if (/^[0-9]{10}$/.test(values.cellphone) === false) {
        error.cellphone = "El número de celular debe contener 10 caracteres numéricos."
    }
    
    return error
}

const maxLengthReference = (value, allValues, props) => {

    const { AgreementForm } = props.agreementsSelected

    if(AgreementForm.length > 0){

        if(value.length > parseInt(AgreementForm[1].maxLength)){
            return `Debe tener ${AgreementForm[1].maxLength} carácteres o menos.`
        }else{
            return undefined
        }
    }else{
        return undefined
    }
}

const validateReference = (value, allValues, props) => {

    const { AgreementForm } = props.agreementsSelected

    if(AgreementForm.length > 0){

        let exp = new RegExp(AgreementForm[1].pattern);

        if(exp.test(value) === false){
            return AgreementForm[1].messageValidationPattern
        }else{
            return undefined
        }
    }else{
        return undefined
    }
    
}

const ElectronicRechargesForm = props => {

    const classes = useStyles();

    const { handleSubmit, agreementsSelected, setAgreementsSelected, agreements, onCancelAction, isActionFavorite, cellphone, invalid } = props

    return (
        <div className={classes.divStandard}>
            <form className={classes.form} onSubmit={ handleSubmit }>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <Autocomplete
                            id="combo-box-demo"
                            value={ agreementsSelected }
                            options={agreements}
                            disableClearable
                            disabled = { isActionFavorite }
                            getOptionLabel={(option) => (option.name) ? option.name : ""}
                            style={{ width: '100%' }}
                            onChange = { (e, nv) => {
                                            setAgreementsSelected(nv)
                                        }}
                            renderInput={(params) => <TextField {...params} label={"Seleccione una operadora"} variant="outlined" />}
                        />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        {
                            //console.log(cellphone)
                            isActionFavorite ? 
                                <List>
                                    
                                    <ListItem>
                                        <ListItemAvatar>
                                            <PhoneIcon />
                                        </ListItemAvatar>
                                        <ListItemText primary={ "Número de Celular" } secondary={ cellphone } />
                                    </ListItem>
                                            
                                </List> : 
                                <Field
                                    name="cellphone"
                                    id="cellphone"
                                    autoFocus = { true }
                                    //disabled = { isActionFavorite }
                                    component={ RenderTextFieldRedux }
                                    label="Número de Celular"
                                    fullWidth
                                />
                        }
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        {
                            (agreementsSelected.AgreementForm.length === 2) ? 

                                (agreementsSelected.AgreementForm[1].element.type === "text") ? 

                                    <Field
                                        name="amount"
                                        id="amount"
                                        validate = { [validateReference, maxLengthReference]}
                                        component={ RenderTextFieldRedux }
                                        label="Monto"
                                        fullWidth
                                    />
                                : 
                                    <Field
                                        data = { agreementsSelected.AgreementForm[1].options }
                                        labelId="demo-simple-select-filled-label"
                                        id="amount"
                                        name="amount"
                                        value={agreementsSelected.AgreementForm[1].options[0]}
                                        label= { "Paquete" }
                                        validate = { [validateReference, maxLengthReference]}
                                        component={ RenderSelectFieldRedux } >
                                    </Field>
                            :
                            <Field
                                name="amount"
                                id="amount"
                                validate = { [validateReference, maxLengthReference]}
                                component={ RenderTextFieldRedux }
                                label="Monto"
                                fullWidth
                            />
                        }
                        
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        
                        <Typography align = "justify">
                            Estos paquetes contienen Minutos, WhatsApp, Facebook, Messenger e Instagram dependiendo de la operadora.
                        </Typography>
                        
                    </Grid>
                    <Grid item xs={6} md={6} lg={6} xl={6}>
                        <Button variant="contained" type="submit"
                            fullWidth
                            color='primary'
                            disabled={invalid}
                            >
                            Consultar
                        </Button>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6} xl={6}>
                        <Button color='primary' variant="outlined" fullWidth onClick = { () => onCancelAction() }>
                            Cancelar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </div>
    )
}

const ElectronicRechargesFormReduxForm = reduxForm(
    {
        form: 'ElectronicRechargesForm',
        validate
    }
)(ElectronicRechargesForm)
export default ElectronicRechargesFormReduxForm
